<!-- <h2 mat-dialog-title>Edit {{data.fieldName}}</h2> -->
<mat-dialog-content>

  <div class="main-text-edit-box">
		<h5>Edit {{data.fieldName}}</h5>
    <div class="section-desc-bx">
      <div class="desc-textarea">
        <textarea name="" id="" cols="30" rows="3" required [maxlength]="300" [(ngModel)]="data.fieldText" [maxlength]="data.limit > 0 ? data.limit : null"></textarea>
        <p *ngIf="data.limit">{{data.limit - data.fieldText.length}} characters left</p>
      </div>
    </div>
  </div>

</mat-dialog-content>
<mat-dialog-actions align="end">
  <button class="cancel-btn" mat-button (click)="onNoClick()">Cancel</button>
  <button class="save-btn" mat-button (click)="saveDetails()">Save</button>
</mat-dialog-actions>
